import { makeStyles, Tab, Tabs, Theme, withStyles } from '@material-ui/core';
import Colors from 'modules/Colors';

const useStyles = makeStyles((theme: Theme) => ({
    svgRotated: {
        transform: 'rotate(-90deg)',
        width: 24,
        height: 24,
        cursor: 'pointer',
        color: Colors.greyDark,
    },
    svgEnabledContainer: {
        '& :hover': {
            color: Colors.purple,
        },
    },
    svgDisabledContainer: {
        '& :hover': {
            color: Colors.greyLight,
        },
    },
    svgGray: {
        width: '24px',
        height: 24,
        cursor: 'pointer',
        color: Colors.greyDark,
    },
    svgDisabled: {
        width: 24,
        height: 24,
        cursor: 'pointer',
        color: Colors.greyLight,
    },
    datagridRoot: {
        '& .MuiDataGrid-iconSeparator': {
            display: 'none',
        },
        '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#edecf252',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            color: Colors.greyDark,
        },
    },
}));


export const CustomTabs = withStyles({
    indicator: {
        backgroundColor: Colors.purple,
    },
})(Tabs);

export const CustomTab = withStyles((theme) => ({
    root: {
        minWidth: 'auto',
        padding: '6px 20px',
        '&$selected': {
            color: Colors.purple,
        },
    },
    selected: {},
}))(Tab);

export default useStyles;
